import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/** Match screens are phone-designed; cap to a centered column so wide web doesn't smear the hero. */
export const MATCH_HUB_MAX_WIDTH = 600;

export function getMatchHubStyles(theme: Theme) {
  return StyleSheet.create({
    flex: {
      flex: 1,
    },
    scrollContent: {
      paddingBottom: theme.spacing.xxxl,
      paddingHorizontal: theme.spacing.sm,
    },
    /** Centered, phone-width column shared by hero + tabs + panels on large screens. */
    content: {
      width: '100%',
      maxWidth: MATCH_HUB_MAX_WIDTH,
      alignSelf: 'center',
    },
    bodyBg: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    errorContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 32,
      paddingBottom: 48,
      backgroundColor: theme.background.primary,
    },
    errorTitle: {
      fontSize: 18,
      fontWeight: '700',
      color: theme.gray[700],
      marginBottom: 8,
      textAlign: 'center',
    },
    errorSubtitle: {
      fontSize: 14,
      color: theme.gray[400],
      textAlign: 'center',
      lineHeight: 20,
      marginBottom: 24,
    },
    errorButton: {
      paddingHorizontal: 24,
      paddingVertical: 10,
      borderRadius: 20,
      backgroundColor: theme.primary,
    },
    errorButtonLabel: {
      fontSize: 14,
      fontWeight: '700',
      color: theme.onPrimary,
    },
    errorIconWrap: {
      marginBottom: 16,
    },
  });
}
